
<template>
  <div class="home">
    <!-- Desktop -->
    <div class="d-none d-xl-flex text-secondary w-auto" ref="homeCards">
      <home-card
        v-for="(card, index) in availableCards"
        :key="card.path"
        v-bind="card"
        :class="{
          'border-right border-configurator-light':
            index !== availableCards.length - 1,
        }"
        @card-click="openTypeSelection"
      />
      <!-- fbgs -->
      <div
        class="home-card d-flex flex-column align-items-end w-25"
        v-if="$store.state.enabledConfiguratorTypes.fbgs"
      >
        <div
          class="w-100 py-1 d-lg-none text-secondary font-weight-bold text-center align-self-center bg-light border-top shadow-sm"
        >
          FBGS
        </div>
        <a href="/config/fbgs"
          ><img
            class="img-fluid mt-1"
            :src="`${$pathPrefix}/assets/welcome-pics/fbgs.png`"
        /></a>
        <p class="product-type-description px-3 w-100">
          {{ $t(`welcome.fbgs`) }}
        </p>
        <a
          class="mr-3 mb-3 float-right bg-saka-orange px-4 py-2 rounded-pill text-white mt-auto"
          href="/config/fbgs"
          >{{ $t("step-forward") }}</a
        >
      </div>
      <div
        class="home-card d-flex flex-column align-items-end flex-grow-1"
        v-else
      ></div>
    </div>

    <!-- Mobile -->
    <div class="d-flex d-xl-none flex-column border-configurator w-100 h-100">
      <div class="p-2 mx-auto mt-5 flex-grow-1">
        <img
          :src="`${$pathPrefix}/assets/mobile-home-screen_v2.svg`"
          alt="Konfigurator Startseite"
          :width="$runtimeEnvironment.isMobileOnly ? 200 : 360"
        />
      </div>
      <p class="text-secondary text-center flex-grow-1 h5 px-2">
        Wählen Sie eine Kabelart aus und starten Sie mit der Konfiguration
      </p>
      <div class="flex-grow-1"></div>

      <div
        class="accordions d-flex flex-column flex-grow-0"
        :class="{ 'mb-4': mobileSurvicateLoaded }"
      >
        <base-accordion
          v-for="accordion in accordionsForMobile"
          :key="accordion.title"
          :id="accordion.id"
        >
          <template v-slot:title>{{ accordion.title }}</template>
          <template v-slot:content>
            <div class="d-flex flex-column px-1 py-2 w-100">
              <div class="d-flex justify-content-between align-items-center">
                <img
                  :src="`${$pathPrefix}/assets/welcome-pics/mobile/${accordion.id}.png`"
                  :alt="`${accordion.title}`"
                  class="img-fluid w-auto"
                  height="100%"
                />
                <button
                  v-if="accordion.comingSoon === false"
                  class="btn bg-saka-orange text-light px-3 py-1 rounded-pill"
                  @click="openTypeSelection(accordion)"
                >
                  {{ $t("step-forward") }}
                </button>
                <button
                  v-else
                  class="btn btn-outline border-saka-orange text-saka-orange px-3 py-1 rounded-pill"
                  disabled
                >
                  Coming Soon
                </button>
              </div>
              <p class="mt-3">{{ accordion.content }}</p>
            </div>
          </template>
        </base-accordion>

        <base-accordion
          key="fbgs"
          v-if="$store.state.enabledConfiguratorTypes.fbgs"
        >
          <template v-slot:title>FBGS</template>
          <template v-slot:content>
            <div class="d-flex flex-column px-1 py-2 w-100">
              <div class="d-flex justify-content-between align-items-center">
                <img
                  :src="`${$pathPrefix}/assets/welcome-pics/mobile/fbgs.png`"
                  :alt="`FBGS`"
                  class="img-fluid w-auto"
                  height="100%"
                />
                <a
                  class="btn bg-saka-orange text-light px-3 py-1 rounded-pill"
                  href="/config/fbgs"
                  >{{ $t("step-forward") }}</a
                >
              </div>
              <p class="mt-3">{{ $t("welcome.fbgs") }}</p>
            </div>
          </template>
        </base-accordion>
      </div>
    </div>

    <!-- Image Slider -->
    <portal to="progression-steps">
      <div class="d-flex flex-column text-secondary" style="width: 100%">
        <div
          class="image-slider-container mb-4"
          v-if="showSlider == 'dont use now'"
        >
          <div class="slider-wrapper">
            <div class="slider-container" ref="slider">
              <div
                v-for="(image, index) in sliderImages"
                :key="index"
                class="slide"
                :class="{ active: index === currentSlideIndex }"
              >
                <img
                  :src="`${$pathPrefix}${image.src}`"
                  :alt="image.alt"
                  class="slider-image"
                />
                <div
                  class="slide-content"
                  v-if="image.title || image.description"
                >
                  <h3 v-if="image.title" class="slide-title">
                    {{ image.title }}
                  </h3>
                  <p v-if="image.description" class="slide-description">
                    {{ image.description }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Slider Navigation -->
            <button
              class="slider-nav prev"
              @click="prevSlide"
              :disabled="currentSlideIndex === 0"
            >
              <i class="fas fa-chevron-left"></i>
            </button>
            <button
              class="slider-nav next"
              @click="nextSlide"
              :disabled="currentSlideIndex === sliderImages.length - 1"
            >
              <i class="fas fa-chevron-right"></i>
            </button>

            <!-- Slider Indicators -->
            <div class="slider-indicators">
              <button
                v-for="(image, index) in sliderImages"
                :key="index"
                class="indicator"
                :class="{ active: index === currentSlideIndex }"
                @click="goToSlide(index)"
              ></button>
            </div>
          </div>
        </div>
        <!-- Hero Section -->
        <div
          class="d-flex flex-wrap align-items-center justify-content-between px-5 py-5 hero-section"
          style="background: #fff; min-height: 500px; gap: 40px"
          v-if="showSlider"
        >
          <!-- Left Content -->
          <div class="hero-text" style="flex: 1 1 500px; max-width: 600px">
            <h2
              style="
                font-size: 2.3rem;
                font-weight: 700;
                color: #7f8c8d;
                margin-bottom: 1rem;
              "
            >
              Configure your own Fiber Optic Cable
            </h2>
            <p style="font-size: 1.2rem; color: #90989d; margin-bottom: 0.7rem">
              in only 4 steps
            </p>
            <div
              style="font-size: 1.05rem; color: #878787; margin-bottom: 1.2rem"
            >
              Your configuration starts here:
            </div>
            <div class="button-row mb-3" style="display: flex; gap: 18px">
              <button
                class="btn bg-warning text-white font-weight-bold rounded-pill px-4 py-2 shadow-sm"
                style="font-size: 1rem"
                @click="scrollToCards"
              >
                Configure your own Fiber Optic Cable
              </button>
            </div>

            <h3
              style="
                font-size: 1.3rem;
                color: #7f8c8d;
                font-weight: bold;
                margin-top: 2rem;
                margin-bottom: 0.4rem;
              "
            >
              Pick Your Perfect Cable
            </h3>
            <p style="font-size: 1rem; color: #90989d">
              Tailor it to your needs
            </p>
          </div>

          <!-- Right Image -->
          <div class="hero-image" style="flex: 1 1 450px; text-align: center">
            <img
              src="assets/welcome-pics/desktop.png"
              alt="Configurator Preview"
              style="
                width: 100%;
                max-width: 500px;
                border-radius: 14px;
                box-shadow: 0 8px 28px rgba(0, 0, 0, 0.08);
                object-fit: contain;
              "
            />
          </div>
        </div>

        <h5><i class="fas fa-palette mr-1"></i>{{ $t("welcome.heading") }}</h5>
        <p>{{ $t("welcome.description") }}</p>
      </div>
    </portal>

    <!-- Type Selection Popup -->
    <div
      v-if="showTypePopup"
      class="popup-overlay d-flex align-items-center justify-content-center"
      @click.self="closePopup"
    >
      <div class="popup-content bg-white rounded shadow-lg p-4 text-center">
        <h5 class="mb-3">{{ $t("selectConfigurationType") }}</h5>
        <p class="text-muted mb-4">
          {{ $t("choosePreferredStandardFor") }} {{ selectedCardTitle }}
        </p>
        <div class="d-flex justify-content-center">
          <button
            class="btn btn-secondary flex-fill mx-1"
            :class="{ active: selectedType === 'sachsenkabel' }"
            @click.stop="selectType('sachsenkabel')"
          >
            {{ $t("telecommunicationsProducts") }}
          </button>
          <button
            class="btn btn-secondary flex-fill mx-1"
            :class="{ active: selectedType === 'rz' }"
            @click.stop="selectType('rz')"
          >
            {{ $t("datacenterproducts") }}
          </button>
        </div>
        <div class="mt-4">
          <button
            class="btn bg-saka-orange text-white px-4 py-2 rounded-pill"
            @click="confirmSelection"
          >
            {{ $t("continue") }}
          </button>
          <button class="btn btn-outline-secondary ml-2" @click="closePopup">
            {{ $t("cancel") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeCard from "@/components/HomeCard";
import BaseAccordion from "@/components/BaseAccordion";
import { mapState } from "vuex";

export default {
  name: "Home",
  components: { HomeCard, BaseAccordion },
  data() {
    return {
      cards: [
        { path: "patch-cord", comingSoon: false },
        { path: "breakout", comingSoon: false },
        { path: "trunk", comingSoon: false },
        { path: "fanout", comingSoon: true },
        // DISABLED - Cake module removed
        // { path: "cake", comingSoon: true },
      ],
      accordionsForMobile: [
        {
          id: "patch-cord",
          title: this.$t("patch-cord"),
          content: this.$t("welcome.patch-cord"),
          comingSoon: false,
        },
        {
          id: "breakout",
          title: this.$t("breakout"),
          content: this.$t("welcome.breakout"),
          comingSoon: false,
        },
        {
          id: "trunk",
          title: this.$t("trunk"),
          content: this.$t("welcome.trunk"),
          comingSoon: false,
        },
        // DISABLED - Cake module removed
        // {
        //   id: "cake",
        //   title: this.$t("cake"),
        //   content: this.$t("welcome.cake"),
        //   comingSoon: false,
        // },
      ],
      sliderImages: [
        {
          src: "https://cdn.sachsenkabel.de/assets/cf2c9875-0dc4-498b-be83-5cd94cc1b128?fit=inside&width=1920&height=687&quality=50&format=auto",
          alt: "Quality Products",
          title: "Premium Quality",
          description: "High-quality cables for all your connectivity needs",
        },
        {
          src: "https://directus-api.sachsenkabel.de/uploads/_/originals/Featureseite_Pr%C3%BCfprotokolle.png",
          alt: "Cable Configurator Solutions",
          title: "Advanced Cable Solutions",
          description:
            "Configure your perfect cable solution with our advanced tools",
        },
        {
          src: "https://cdn.sachsenkabel.de/assets/4bdb6195-ab66-4f50-9d7f-1b673b541985?fit=inside&width=1920&height=687&quality=50&format=auto",
          alt: "Fast Configuration",
          title: "Quick & Easy",
          description: "Fast configuration process with instant results",
        },
      ],
      currentSlideIndex: 0,
      autoplayInterval: null,
      autoplayDelay: 5000,
      showSlider: false,
      showTypePopup: false,
      selectedType: null,
      selectedCard: null,
      selectedCardTitle: "",
    };
  },
  computed: {
    ...mapState(["mobileSurvicateLoaded"]),

    availableCards() {
      const mapped = this.cards.map((i) => ({
        ...i,
        newPath: i.path.replace("-", ""),
      }));
      const filtered = mapped.filter(
        (i) => this.$store.state.enabledConfiguratorTypes[i.newPath]
      );

      // DISABLED - Cake module removed
      // ✅ Always include "cake" card if it exists
      // const userSource = localStorage.getItem("userSource");
      // const cakeCard = mapped.find((i) => i.newPath === "cake");
      // if (
      //   cakeCard &&
      //   !filtered.includes(cakeCard) &&
      //   userSource !== "digikey"
      // ) {
      //   filtered.push(cakeCard);
      // }

      return filtered;
    },
  },
  mounted() {
    const userSource = localStorage.getItem("userSource");
    if (userSource === "digikey") this.showSlider = true;
    this.startAutoplay();
  },
  beforeDestroy() {
    this.stopAutoplay();
  },
  methods: {
    // --- Popup Logic ---
    openTypeSelection(card) {
      const userSource = localStorage.getItem("userSource");
      this.selectedCard = card;
      this.selectedCardTitle =
        card.title || (card.path ? card.path.replace("-", " ") : card.id);

      // DISABLED - Cake module removed
      // 🎟️ Voucher logic for "cake"
      // if (card.path === "cake" && userSource !== "digikey") {
      //   const validVoucher = "amphenolsachsenkabel"; // hardcoded for now
      //   const enteredCode = prompt(
      //     "Please enter your voucher code to access Cake Configurator:"
      //   );
      //
      //   if (enteredCode === null) {
      //     // User cancelled input
      //     return;
      //   }
      //
      //   if (enteredCode.trim().toUpperCase() === validVoucher.toUpperCase()) {
      //     // ✅ Voucher matched → proceed to Cake page
      //     this.$router.push("/cake");
      //   } else {
      //     // ❌ Invalid code
      //     alert("Invalid voucher code. Please try again.");
      //   }
      //
      //   return; // stop further logic
      // }

      // 🔹 Existing logic for Digikey / others
      if (userSource === "digikey") {
        this.showTypePopup = true;
      } else {
        const targetUrl = `${card.path}`;
        this.$router.push(targetUrl);
      }
    },

    closePopup() {
      this.showTypePopup = false;
      this.selectedType = null;
    },
    selectType(type) {
      this.selectedType = type;
    },
    confirmSelection() {
      if (!this.selectedType) {
        alert("Please select a type before continuing.");
        return;
      }
      // Commit the selection to Vuex store for global access
      this.$store.commit("setConfiguratorType", this.selectedType);
      // eslint-disable-next-line no-console
      // console.log("this.selectedType",this.selectedType)
      const targetUrl = `${this.selectedCard.path}`;
      this.closePopup();
      this.$router.push(targetUrl);
    },

    // --- Slider Logic ---
    nextSlide() {
      this.currentSlideIndex =
        (this.currentSlideIndex + 1) % this.sliderImages.length;
      this.resetAutoplay();
    },
    prevSlide() {
      this.currentSlideIndex =
        (this.currentSlideIndex - 1 + this.sliderImages.length) %
        this.sliderImages.length;
      this.resetAutoplay();
    },
    goToSlide(index) {
      this.currentSlideIndex = index;
      this.resetAutoplay();
    },
    startAutoplay() {
      this.autoplayInterval = setInterval(
        () => this.nextSlide(),
        this.autoplayDelay
      );
    },
    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    },
    resetAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    },
    scrollToCards() {
      const cardsSection = this.$refs.homeCards;
      if (cardsSection) {
        cardsSection.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>

<style scoped>
/* Popup Styles */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}
.popup-content {
  width: 90%;
  max-width: 600px;
  animation: fadeInUp 0.3s ease;
}
button.active {
  background-color: #ff6b00 !important;
  color: #fff !important;
  border: none !important;
}
@keyframes fadeInUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Image Slider Styles */
.image-slider-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}
.slider-wrapper {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}
.slider-container {
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
}
.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.6s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
}
.slide.active {
  opacity: 1;
}
.slider-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.slide-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  color: white;
  padding: 40px 30px 30px;
  text-align: left;
}
.slide-title {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 10px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}
.slide-description {
  font-size: 1.1rem;
  margin: 0;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}
/* Navigation Buttons */
.slider-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
  font-size: 18px;
  color: #333;
}
.slider-nav:hover:not(:disabled) {
  background: rgba(255, 255, 255, 1);
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}
.slider-nav:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.slider-nav.prev {
  left: 20px;
}
.slider-nav.next {
  right: 20px;
}
/* Indicators */
.slider-indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 10;
}
.indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.7);
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
}
.indicator.active {
  background: white;
  border-color: white;
}
.indicator:hover {
  border-color: white;
  background: rgba(255, 255, 255, 0.5);
}
/* Responsive */
@media (max-width: 768px) {
  .slider-container {
    height: 250px;
  }
  .slide-title {
    font-size: 1.5rem;
  }
  .slide-description {
    font-size: 1rem;
  }
  .slide-content {
    padding: 20px;
  }
  .slider-nav {
    width: 40px;
    height: 40px;
    font-size: 14px;
  }
  .slider-nav.prev {
    left: 10px;
  }
  .slider-nav.next {
    right: 10px;
  }
}
@media (max-width: 576px) {
  .slider-container {
    height: 200px;
  }
  .slide-title {
    font-size: 1.2rem;
  }
  .slide-description {
    font-size: 0.9rem;
  }
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 998;
}
.modal-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  z-index: 999;
  border-radius: 10px;
  min-width: 300px;
  max-width: 90vw;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}
.modal-content {
  padding: 20px;
}

.hero-section {
  display: flex;
  align-items: center; /* Ensures text & image vertical alignment */
}

.hero-text,
.hero-image {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* Responsive layout fix */
@media (max-width: 992px) {
  .hero-section {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }

  .hero-text {
    align-items: center;
  }

  .hero-image img {
    max-width: 350px;
  }
}
</style>
